export class DeleteShot {
  public OrderImageId: number;
  public ShotId: number;

  constructor(orderImageId: number, shotId: number) {
    this.OrderImageId = orderImageId;
    this.ShotId = shotId;
  }
}
